var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCaseDate)?_c('div',{staticClass:"v2026-casedate"},[_c('div',[_vm._v("เคสสนทนาของวันที่: "+_vm._s(_vm.formattedCaseDate))]),(_vm.showOriginalDate)?_c('div',[_vm._v("(สนทนาครั้งแรก: "+_vm._s(_vm._f("prettyDate")(_vm.createdAt))+" )")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }